import LocalStorageKeys from "../client-portal/common/enums/local-storage-keys";
import localStorage from "../helpers/localStorage";
import sessionStorage from "../helpers/sessionStorage";

export interface UserData {
  message: string;
  userId: number;
  token: string;
}

export const sessionOrLocalStorageUserData = (): string | null =>
  sessionStorage.getItem("user") || localStorage.getItem("user");

export const sessionOrLocalStorageClientPortalData = (): string | null =>
  sessionStorage.getItem(LocalStorageKeys.USER) || localStorage.getItem(LocalStorageKeys.USER);

export const saveAuthData = (userdata: UserData, storage = localStorage): void => {
  storage.setItem("user", JSON.stringify(userdata));
};

export const isTokenValid = (data?: UserData): boolean => {
  if (!data) {
    const user = sessionOrLocalStorageUserData();
    if (!user) return false;
  }
  return true;
};

export const isAuthenticated = (): boolean => {
  const user = sessionOrLocalStorageUserData();
  try {
    return Boolean(user) && isTokenValid(JSON.parse(user as string));
  } catch {
    return false;
  }
};

/**
 * @todo implement client portal users
 */
export const isClientPortalUserAuthenticated = (): boolean => {
  const user = sessionOrLocalStorageClientPortalData();
  try {
    return Boolean(user) && isTokenValid(JSON.parse(user as string));
  } catch {
    return false;
  }
};

export const getToken = (): string => JSON.parse(sessionOrLocalStorageUserData() as string)?.token;

export const removeAuthData = (): void => {
  localStorage.removeItem(LocalStorageKeys.USER);
};

export const saveClientPortalUser = (userdata: UserData, storage = localStorage): void => {
  storage.setItem(LocalStorageKeys.CLIENT_PORTAL_USER, JSON.stringify(userdata));
};

export const removeClientPortalAuthdata = (): void => {
  localStorage.removeItem(LocalStorageKeys.CLIENT_PORTAL_USER);
};

export const hasClientPortalAuth = (): boolean =>
  Boolean(JSON.parse(sessionOrLocalStorageUserData() as string)?.isClientPortalUser);
